import { createContext } from "react";
import type { SeasonCheckboxKey } from "./SeasonContextProvider";
import type { SeasonCheckboxes } from "../utils/types";
import { ApplicationPeriod } from "../../../api/season";

// This is the information on our users. So all userdata related to THEIR pickup.

export interface SeasonContextType {
  loading: boolean;
  error: string | null;
  areWeInSeason: boolean;
  seasonPreviewOverride: boolean | null; //PREVIEW only
  applicationPeriod: ApplicationPeriod;
  applicationPeriodPreviewOverride: ApplicationPeriod | null; //PREVIEW only
  freeDeliveryThreshold: number;
  businessDeliveryPrice: number;
  csaDeliveryPrice: number;
  checkboxes: SeasonCheckboxes;
  waitlist: string[];
  isBusinessOpen: boolean;
  /** Resolves true when the user was already on the waitlist. */
  joinWaitlist: () => Promise<boolean>;
  updateAreWeInSeason: (inSeason: boolean) => Promise<boolean>;
  updateIsBusinessOpen: (open: boolean) => void;
  updateApplicationPeriod: (period: ApplicationPeriod) => void;
  updateShippingPricing: (
    freeDeliveryThreshold: number,
    businessDeliveryPrice: number,
  ) => void;
  updateCSADeliveryPrice: (csaDeliveryPrice: number) => void;
  toggleCheckbox: (item: SeasonCheckboxKey) => void;
  setSeasonPreviewOverride: (inSeason: boolean | null) => void; //PREVIEW only
  clearSeasonPreviewOverride: () => void; //PREVIEW only
  setApplicationPeriodPreviewOverride: (
    period: ApplicationPeriod | null,
  ) => void; //PREVIEW only
  clearApplicationPeriodPreviewOverride: () => void; //PREVIEW only
}

export const SeasonContext = createContext<SeasonContextType>({
  loading: false,
  error: null,
  areWeInSeason: false,
  seasonPreviewOverride: null, //PREVIEW only
  applicationPeriod: ApplicationPeriod.ApplicationClosed,
  applicationPeriodPreviewOverride: null, //PREVIEW only
  freeDeliveryThreshold: 1000,
  businessDeliveryPrice: 80,
  csaDeliveryPrice: 80,
  checkboxes: {
    printHarvestLogs: false,
    printOrders: false,
    updatePickupLocations: false,
    updateSubscriptionsAndTiers: false,
    updateCsaDeliveryPrice: false,
  },
  isBusinessOpen: false,
  waitlist: [],
  joinWaitlist: () => Promise.resolve(false),
  updateAreWeInSeason: () => Promise.resolve(false),
  updateIsBusinessOpen: () => Promise.resolve(),
  updateApplicationPeriod: () => Promise.resolve(),
  updateShippingPricing: () => Promise.resolve(),
  updateCSADeliveryPrice: () => Promise.resolve(),
  toggleCheckbox: () => Promise.resolve(),
  setSeasonPreviewOverride: () => Promise.resolve(), //PREVIEW only
  clearSeasonPreviewOverride: () => Promise.resolve(), //PREVIEW only
  setApplicationPeriodPreviewOverride: () => Promise.resolve(), //PREVIEW only
  clearApplicationPeriodPreviewOverride: () => Promise.resolve(), //PREVIEW only
});
